import { NewColor } from '@factorialco/f0-react'
import { AtsQuestionTypeEnum } from 'generated/resources/datatable.graphql'
import { AnswerFragment } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import SafeJSON from 'modules/core/lib/SafeJSON'
import i18n from 'modules/core/lib/i18n'

export const getQuestionTypeLabel = (type: string) => {
  switch (type) {
    case 'text':
      return i18n.t('ats.questions.types.text')
    case 'long_text':
      return i18n.t('ats.questions.types.long_text')
    case 'single_choice':
      return i18n.t('ats.questions.types.single_choice')
    case 'multiple_choice':
      return i18n.t('ats.questions.types.multiple_choice')
    case 'file':
      return i18n.t('ats.questions.types.file')
    default:
      return '-'
  }
}

export const getQuestionTagColor = (type: AtsQuestionTypeEnum) => {
  const tagsColors: Record<AtsQuestionTypeEnum | 'default', NewColor> = {
    text: 'purple',
    long_text: 'flubber',
    single_choice: 'yellow',
    multiple_choice: 'malibu',
    file: 'smoke',
    default: 'flubber',
  }

  return tagsColors[type]
}

export const questionTypeHasOptions = (type: AtsQuestionTypeEnum) => {
  return ['single_choice', 'multiple_choice'].includes(type)
}

export const answerHasNoResponse = (answer: AnswerFragment) => {
  return isEmpty(answer.value) && isEmpty(answer.files)
}

export const getMultipleChoiceValue = (answer: Pick<AnswerFragment, 'value'>) => {
  return SafeJSON.parse(answer.value, [])
}
